<template>
    <div>
        <section class="folders-section section py-5 px-5">
            <p class="px-5 pt-4 ml-3 is-size-4 has-text-black">
                <span class="icon-text mr-2 pt-1">
                    <span class="icon pt-2">
                        <i class="mdi mdi-36px mdi-folder-outline"></i>
                    </span>
                </span>
                <span class="ml-2">{{folder.name}}</span>
            </p>
        </section>
        <div class="section">
            <n-projects-grid :projects="folder.projects" :showCreationCard="true" @toggleHighlight="toggleHighlight"/>
        </div>
    </div>
</template>

<script>
import { fetchItem } from '@/services/API';
import NProjectsGrid from '@/components/NProjectsGrid';
import _ from 'underscore';
export default {
    components: {
        NProjectsGrid,
    },
    props: {},
    data() {
        return {
            folder: {},
        };
    },
    mounted() {
        fetchItem('folder', this.$route.params.folder).then(({ data }) => {
            this.folder = data;
        });
    },
    watch: {
        '$route.params.folder': function (newValue) {
            if (newValue) {
                fetchItem('folder', this.$route.params.folder).then(({ data }) => {
                    this.folder = data;
                });
            }
        },
    },
    methods: {
        toggleHighlight(project) {
            //this.$emit("toggleHighlight",project)
             const updatedIndex = _.findIndex(this.folder.projects, {
                _id: project._id,
            });

            this.folder.projects.splice(updatedIndex, 1, project);
        }
    },
};
</script>

<style></style>
